/* ==========================================================================
   Secret Stories PDP, CRO Variant 1, Vanilla JS interactions
   No framework. Reads config from a `data-cro-v1-config` JSON blob in the section.
   All listeners are scoped to the .cro-v1 root.
   ========================================================================== */
(function () {
  'use strict';

  // Wait for DOM ready
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function init() {
    var root = document.querySelector('.cro-v1');
    if (!root) return;

    // -----------------------
    // Config (from Liquid → data-cro-v1-config JSON blob)
    // -----------------------
    var config = {};
    try {
      var configEl = root.querySelector('[data-cro-v1-config]');
      if (configEl) config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.warn('[cro-v1] could not parse config', e);
    }

    var TIERS = (config.tiers || []).reduce(function (acc, t) {
      acc[String(t.id)] = t;
      return acc;
    }, {});

    var fmt = function (n) {
      return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // -----------------------
    // Educator Starter Pack (optional third kit option)
    // Only exists when the section detected the standalone add-on product
    // (handle educator-starter-pack-upgrade or educator-starter-pack) in the
    // store and rendered the extra toggle + config keys. The starter tier =
    // the VALUE PACK variant PLUS the add-on product, posted together in one
    // /cart/add.js call (see addToCart).
    // Every starter code path below is guarded on hasStarter, so two-kit PDPs
    // (including the workbook PDP) execute exactly the same logic as before.
    // -----------------------
    var hasStarter = !!(config.hasStarter && root.getAttribute('data-has-starter') === 'true');
    var STARTER = hasStarter && config.starterPricing && typeof config.starterPricing.price === 'number'
      ? config.starterPricing
      : null;
    if (!STARTER) hasStarter = false;
    // The add-on variant id is required for the two-item cart add. If it is
    // missing, the starter tier behaves as if absent: hasStarter goes false
    // and every starter guard below stays on the legacy path.
    var STARTER_ADDON_ID = hasStarter && config.starterAddonVariantId ? config.starterAddonVariantId : null;
    if (!STARTER_ADDON_ID) {
      STARTER = null;
      hasStarter = false;
    }

    // Price for the currently selected kit. For standard/value this is always
    // the tier price (unchanged legacy behavior). Only when the starter option
    // exists AND is the selected kit do we read the starter variant price.
    function getActivePrice(tier) {
      if (hasStarter && selectedKit === 'starter') {
        return STARTER.price;
      }
      return tier ? tier.price : null;
    }

    // -----------------------
    // 1) Urgency countdown
    // -----------------------
    var countdownEls = root.querySelectorAll('[data-cro-cd]');
    if (countdownEls.length) {
      var state = { d: 2, h: 14, m: 23, s: 47 };
      var pad = function (n) { return String(n).padStart(2, '0'); };
      function tick() {
        state.s--;
        if (state.s < 0) { state.s = 59; state.m--; }
        if (state.m < 0) { state.m = 59; state.h--; }
        if (state.h < 0) { state.h = 23; state.d--; }
        if (state.d < 0) state.d = 0;
        countdownEls.forEach(function (el) {
          var k = el.getAttribute('data-cro-cd');
          el.textContent = k === 'd' ? state.d : pad(state[k]);
        });
      }
      tick();
      setInterval(tick, 1000);
    }

    // -----------------------
    // 2) Quantity tier select (drives ATC button label + price)
    // -----------------------
    var tierBtns = root.querySelectorAll('[data-cro-tier]');
    var atcBtn = root.querySelector('[data-cro-atc]');
    var qtyInput = root.querySelector('[data-cro-qty-input]');
    var selectedTierId = config.defaultTier || (config.tiers && config.tiers[0] && String(config.tiers[0].id));

    var shoppayAmountEl = root.querySelector('[data-cro-shoppay-amount]');
    // Kit toggle price line (workbook multi-tier PDP only). Single-tier PDPs
    // render their kit prices in Liquid without this attribute, so an empty
    // NodeList makes every price sync below a no-op on those pages.
    var kitPriceEls = root.querySelectorAll('[data-cro-kit-price]');
    function selectTier(id) {
      selectedTierId = id;
      tierBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-cro-tier') === id ? 'true' : 'false');
      });
      var tier = TIERS[id];
      // getActivePrice returns tier.price verbatim unless the Educator Starter
      // Pack exists AND is the selected kit (starter has its own price).
      var activePrice = getActivePrice(tier);
      if (tier && atcBtn) {
        atcBtn.textContent = 'ADD TO CART · ' + fmt(activePrice);
        atcBtn.setAttribute('data-cro-tier-id', id);
      }
      // Update Shop Pay 4-installment amount under main ATC (CRO #4)
      if (shoppayAmountEl && tier) {
        shoppayAmountEl.textContent = fmt(activePrice / 4);
      }
      // Sync the kit toggle price line to the newly selected tier. Both kit
      // buttons show the TIER price (kits share tier pricing on the workbook
      // PDP). Guarded so pages without the elements are unaffected.
      if (tier && kitPriceEls.length) {
        kitPriceEls.forEach(function (el) {
          el.textContent = fmt(tier.price);
        });
      }
    }
    tierBtns.forEach(function (b) {
      b.addEventListener('click', function () { selectTier(b.getAttribute('data-cro-tier')); });
    });
    if (selectedTierId) selectTier(selectedTierId);

    // -----------------------
    // 2.5) Hero image carousel: clicking a thumb swaps the main image
    // -----------------------
    var heroMain = root.querySelector('[data-cro-hero-main]');
    var heroThumbs = root.querySelectorAll('[data-cro-hero-thumb]');
    var stickyImg = document.querySelector('[data-cro-sticky-img]');
    if (heroMain && heroThumbs.length) {
      heroThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-cro-hero-thumb');
          var alt = thumb.getAttribute('data-cro-hero-alt') || '';
          if (!src) return;
          // Update active state on thumbs (works for both V1 thumb strip and V2 gallery cells)
          heroThumbs.forEach(function (t) {
            var on = (t === thumb);
            t.classList.toggle('cro-hero__thumb--active', on);
            t.classList.toggle('cro-v2-gallery-thumb--active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          // Soft fade-swap on the main image
          heroMain.classList.add('is-swapping');
          setTimeout(function () {
            heroMain.src = src;
            heroMain.alt = alt;
            // Wait one frame for the new image to start loading, then fade in
            requestAnimationFrame(function () {
              heroMain.classList.remove('is-swapping');
            });
          }, 180);
          // Mirror the swap to the sticky cart's product image
          if (stickyImg) stickyImg.src = src;
        });
      });
    }

    // -----------------------
    // 2.7) Color variant selector - fetches new product via Section Rendering API (no page reload)
    // Uses same-origin Shopify section fetch, content is trusted (server-rendered Liquid).
    // -----------------------
    var colorBtns = root.querySelectorAll('[data-cro-color-handle]');
    var colorSwapping = false;
    if (colorBtns.length) {
      colorBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (colorSwapping) return;
          if (btn.classList.contains('cro-color-select__btn--active')) return;

          var handle = btn.getAttribute('data-cro-color-handle');
          var productUrl = btn.getAttribute('data-cro-color-url');
          if (!handle || !productUrl) return;

          colorSwapping = true;
          btn.style.opacity = '0.6';

          // Shopify Section Rendering API: fetch the same section rendered with the new product.
          // Use the button's own section wrapper - multiple gated CRO sections share the
          // .section-cro-v1 class on the default product template, and querySelector would
          // grab the first (empty) one, silently breaking the swap on non-classkit PDPs.
          var sectionEl = btn.closest('[id^="shopify-section-"]') || document.querySelector('.section-cro-v1');
          var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : 'main';
          // Colorway URLs on the class kit v2 template carry ?view=..., so join
          // section_id with & when the URL already has a query string.
          var fetchUrl = productUrl + (productUrl.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId;

          fetch(fetchUrl)
            .then(function (res) { return res.text(); })
            .then(function (html) {
              // Shopify section rendering returns trusted, server-rendered HTML from same origin.
              // Empty response means the section is handle-gated for the target product; hard navigate.
              if (!html || html.replace(/<[^>]*>/g, '').trim().length < 40) {
                window.location.href = productUrl;
                return;
              }
              if (sectionEl) {
                sectionEl.outerHTML = html;
                // Update the URL without page reload
                history.pushState({ handle: handle }, '', productUrl);
                // Re-initialize JS on the new content
                init();
              }
            })
            .catch(function (err) {
              console.warn('[cro-v1] color swap failed, falling back to navigation', err);
              window.location.href = productUrl;
            })
            .finally(function () {
              colorSwapping = false;
            });
        });
      });
    }

    // Handle browser back/forward after color swap
    window.addEventListener('popstate', function () {
      window.location.reload();
    });

    // -----------------------
    // 3) Kit toggle (Standard / Value Pack, plus optional Educator Starter Pack)
    //    Value Pack adds bonuses incl. 21-day app trial. Starter adds PD + certificate.
    // -----------------------
    var kitBtns = root.querySelectorAll('[data-cro-kit]');
    var selectedKit = config.defaultKit || 'value';
    function selectKit(kit) {
      selectedKit = kit;
      kitBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-cro-kit') === kit ? 'true' : 'false');
      });
      // Set data-kit on root so CSS can show/hide value-pack-only bonus images
      root.setAttribute('data-kit', kit);
      // Starter-only extension: the Educator Starter Pack carries its own price,
      // so re-sync every price display when the kit changes. Guarded so PDPs
      // without a starter variant never run this branch.
      if (hasStarter) {
        selectTier(selectedTierId);
        updateStarterPriceRow();
      }
    }
    kitBtns.forEach(function (b) {
      b.addEventListener('click', function () { selectKit(b.getAttribute('data-cro-kit')); });
    });
    selectKit(selectedKit);

    // Value Pack upgrade checkbox (classkit PDP): checked = Value Pack variant,
    // unchecked = Standard variant. Drives the same selectKit state machine as
    // the button toggle, so pricing, cart variant IDs, and the upsell ladder's
    // app-step logic (app offered only for Standard) are unchanged.
    var kitCheckbox = root.querySelector('[data-cro-kit-checkbox]');
    if (kitCheckbox) {
      kitCheckbox.addEventListener('change', function () {
        selectKit(kitCheckbox.checked ? 'value' : 'standard');
      });
      selectKit(kitCheckbox.checked ? 'value' : 'standard');
    }

    // Payment trust strip + Shop Pay installments line: Clarity logged 88
    // dead clicks on "Shop Pay" in 2 days - shoppers treat the payment icons
    // as express-checkout buttons. Clicking anywhere on either block now
    // triggers the real Add to Cart, which opens the drawer where the actual
    // checkout (incl. Shop Pay) lives.
    root.addEventListener('click', function (e) {
      if (!e.target.closest('.cro-pay-icons, .cro-atc-shoppay')) return;
      var atc = root.querySelector('[data-cro-atc]');
      if (atc) atc.click();
    });

    // Image zoom lightbox: Clarity showed heavy dead clicks on the gallery
    // (teachers wanting a closer look at poster readability). Clicking the
    // main hero image opens a full-screen view with a 1800px asset. Clarity
    // then showed shoppers clicking the enlarged image trying to page through
    // the gallery, so the lightbox is a full carousel: arrows, click-to-
    // advance, swipe, and arrow keys.
    var zoomOverlay = null;
    var zoomList = [];
    var zoomIdx = 0;
    function upsize(src) {
      return String(src).replace(/_900x\./, '_1800x.').replace(/(\?|&)width=900/, '$1width=1800');
    }
    function zoomImages() {
      var thumbs = root.querySelectorAll('[data-cro-hero-thumb]');
      var list = [];
      thumbs.forEach(function (t) {
        var src = t.getAttribute('data-cro-hero-thumb');
        if (src) list.push({ src: src, alt: t.getAttribute('data-cro-hero-alt') || '' });
      });
      return list;
    }
    function renderZoom() {
      if (!zoomOverlay || !zoomList.length) return;
      var item = zoomList[zoomIdx];
      zoomOverlay.querySelector('.cro-zoom__img').src = upsize(item.src);
      zoomOverlay.querySelector('.cro-zoom__img').alt = item.alt;
      var count = zoomOverlay.querySelector('.cro-zoom__count');
      var multi = zoomList.length > 1;
      count.textContent = (zoomIdx + 1) + ' / ' + zoomList.length;
      count.style.display = multi ? '' : 'none';
      zoomOverlay.querySelectorAll('.cro-zoom__nav').forEach(function (b) {
        b.style.display = multi ? '' : 'none';
      });
    }
    function stepZoom(d) {
      if (zoomList.length < 2) return;
      zoomIdx = (zoomIdx + d + zoomList.length) % zoomList.length;
      renderZoom();
    }
    function closeZoom() {
      if (!zoomOverlay) return;
      zoomOverlay.classList.remove('cro-zoom--open');
      document.body.style.overflow = '';
    }
    function openZoom(src, alt) {
      if (!zoomOverlay) {
        zoomOverlay = document.createElement('div');
        zoomOverlay.className = 'cro-zoom';
        zoomOverlay.innerHTML =
          '<button type="button" class="cro-zoom__x" aria-label="Close image">&times;</button>' +
          '<button type="button" class="cro-zoom__nav cro-zoom__nav--prev" aria-label="Previous image">&#8249;</button>' +
          '<img class="cro-zoom__img" alt="">' +
          '<button type="button" class="cro-zoom__nav cro-zoom__nav--next" aria-label="Next image">&#8250;</button>' +
          '<div class="cro-zoom__count"></div>';
        document.body.appendChild(zoomOverlay);
        zoomOverlay.querySelector('.cro-zoom__nav--prev').addEventListener('click', function (e) {
          e.stopPropagation(); stepZoom(-1);
        });
        zoomOverlay.querySelector('.cro-zoom__nav--next').addEventListener('click', function (e) {
          e.stopPropagation(); stepZoom(1);
        });
        // Clicking the enlarged image advances (what dead-click data showed
        // shoppers already trying to do); anywhere else closes.
        zoomOverlay.addEventListener('click', function (e) {
          if (e.target.closest('.cro-zoom__img')) { stepZoom(1); return; }
          if (!e.target.closest('.cro-zoom__nav, .cro-zoom__count')) closeZoom();
        });
        var touchX = null;
        zoomOverlay.addEventListener('touchstart', function (e) {
          touchX = e.touches && e.touches[0] ? e.touches[0].clientX : null;
        }, { passive: true });
        zoomOverlay.addEventListener('touchend', function (e) {
          if (touchX === null || !e.changedTouches || !e.changedTouches[0]) return;
          var dx = e.changedTouches[0].clientX - touchX;
          touchX = null;
          if (Math.abs(dx) > 40) stepZoom(dx < 0 ? 1 : -1);
        }, { passive: true });
        document.addEventListener('keydown', function (e) {
          if (!zoomOverlay.classList.contains('cro-zoom--open')) return;
          if (e.key === 'Escape') closeZoom();
          if (e.key === 'ArrowRight') stepZoom(1);
          if (e.key === 'ArrowLeft') stepZoom(-1);
        });
      }
      zoomList = zoomImages();
      if (!zoomList.length) zoomList = [{ src: src, alt: alt || '' }];
      // Thumb URLs are protocol-relative (//host/...) while img.src is
      // absolute, so compare without the scheme or every zoom opens on image 1.
      var stripUrl = function (u) { return String(u).split('?')[0].replace(/^https?:/, ''); };
      var base = stripUrl(src);
      zoomIdx = 0;
      zoomList.forEach(function (item, i) {
        if (stripUrl(item.src) === base) zoomIdx = i;
      });
      renderZoom();
      zoomOverlay.classList.add('cro-zoom--open');
      document.body.style.overflow = 'hidden';
    }
    // Delegated so the binding survives color-swap re-renders of the hero.
    root.addEventListener('click', function (e) {
      var img = e.target && e.target.closest ? e.target.closest('[data-cro-hero-main]') : null;
      if (!img) return;
      openZoom(img.currentSrc || img.src, img.alt);
    });

    // Curriculum pills: clicking one pulses the "layers on top of any program"
    // note (Clarity showed steady dead clicks on the pills).
    root.querySelectorAll('.cro-hero__compat-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var note = root.querySelector('.cro-hero__compat-note');
        if (!note) return;
        note.classList.remove('cro-hero__compat-note--pulse');
        void note.offsetWidth;
        note.classList.add('cro-hero__compat-note--pulse');
      });
    });

    // In-page jumps for every [data-cro-scroll-target], anchors included.
    // The theme sets html { scroll-behavior: smooth }, and a global third-party
    // script cancels smooth scroll animations mid-flight, so smooth/auto
    // scrollIntoView (and native hash jumps) silently die at the top of the
    // page. behavior:'instant' bypasses the CSS smooth behavior entirely and
    // cannot be cancelled. Re-assert twice in case anything resets afterward.
    function jumpNow(target) {
      try { target.scrollIntoView({ behavior: 'instant', block: 'start' }); }
      catch (e) { target.scrollIntoView(true); }
    }
    function forceScrollTo(target) {
      jumpNow(target);
      var assertPos = function () {
        if (Math.abs(target.getBoundingClientRect().top) > 120) jumpNow(target);
      };
      setTimeout(assertPos, 250);
      setTimeout(assertPos, 700);
    }
    root.querySelectorAll('[data-cro-scroll-target]').forEach(function (el) {
      var jump = function (e) {
        var sel = el.getAttribute('data-cro-scroll-target');
        var target = sel && document.querySelector(sel);
        if (!target) return; // let anchors fall through to native behavior
        if (e) { e.preventDefault(); e.stopPropagation(); }
        forceScrollTo(target);
      };
      el.addEventListener('click', jump);
      if (el.tagName !== 'A') {
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); jump(e); }
        });
      }
    });

    // Starter-only helpers: swap the static single-price row (.cro-ck-price)
    // between the section-rendered tier pricing and the starter variant pricing.
    // Original child nodes are captured once so switching back restores exactly.
    function replaceChildNodes(el, nodes) {
      while (el.firstChild) el.removeChild(el.firstChild);
      nodes.forEach(function (n) { el.appendChild(n); });
    }
    function cloneChildNodes(el) {
      return Array.prototype.slice.call(el.childNodes).map(function (n) { return n.cloneNode(true); });
    }
    var ckPriceOriginal = null;
    function updateStarterPriceRow() {
      if (!hasStarter) return;
      var strikeEl = root.querySelector('.cro-ck-price__strike');
      var currentEl = root.querySelector('.cro-ck-price__current');
      var saveEl = root.querySelector('.cro-ck-price__save');
      var shoppayRowEl = root.querySelector('.cro-ck-price__shoppay');
      if (!currentEl) return;
      if (!ckPriceOriginal) {
        ckPriceOriginal = {
          strike: strikeEl ? strikeEl.textContent : '',
          current: currentEl.textContent,
          save: saveEl ? saveEl.textContent : '',
          shoppayNodes: shoppayRowEl ? cloneChildNodes(shoppayRowEl) : null
        };
      }
      if (selectedKit === 'starter') {
        var hasCompare = typeof STARTER.compare === 'number' && STARTER.compare > STARTER.price;
        var saveAmount = typeof STARTER.saveAmount === 'number' && STARTER.saveAmount > 0
          ? STARTER.saveAmount
          : (hasCompare ? STARTER.compare - STARTER.price : 0);
        if (strikeEl) {
          strikeEl.textContent = hasCompare ? fmt(STARTER.compare) : '';
          strikeEl.style.display = hasCompare ? '' : 'none';
        }
        currentEl.textContent = fmt(STARTER.price);
        if (saveEl) {
          saveEl.textContent = hasCompare ? 'You save ' + fmt(saveAmount) : '';
          saveEl.style.display = hasCompare ? '' : 'none';
        }
        if (shoppayRowEl) {
          var strongEl = document.createElement('strong');
          strongEl.textContent = 'Shop Pay';
          replaceChildNodes(shoppayRowEl, [
            document.createTextNode('or 4 × ' + fmt(STARTER.price / 4) + ' with '),
            strongEl
          ]);
        }
      } else {
        if (strikeEl) { strikeEl.textContent = ckPriceOriginal.strike; strikeEl.style.display = ''; }
        currentEl.textContent = ckPriceOriginal.current;
        if (saveEl) { saveEl.textContent = ckPriceOriginal.save; saveEl.style.display = ''; }
        if (shoppayRowEl && ckPriceOriginal.shoppayNodes) {
          replaceChildNodes(shoppayRowEl, ckPriceOriginal.shoppayNodes.map(function (n) { return n.cloneNode(true); }));
        }
      }
    }

    // -----------------------
    // 4) Quantity stepper (non-tier, the +/- next to ATC)
    // -----------------------
    if (qtyInput) {
      var minus = root.querySelector('[data-cro-qty-minus]');
      var plus = root.querySelector('[data-cro-qty-plus]');
      function setQty(n) {
        var clamped = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
        qtyInput.value = clamped;
      }
      if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) + 1); });
    }

    // -----------------------
    // 5) Delivery estimate (real day-of-week, skips weekends)
    //    If arrival lands on Saturday or Sunday, bump forward to Monday and add a day.
    // -----------------------
    var deliveryDate = root.querySelector('[data-cro-delivery-date]');
    var deliveryNote = root.querySelector('[data-cro-delivery-note]');
    if (deliveryDate) {
      var today = new Date();
      var cutoff = new Date(today); cutoff.setHours(14, 0, 0, 0);
      var beforeCutoff = today < cutoff;
      var ship = new Date(today); ship.setDate(ship.getDate() + (beforeCutoff ? 1 : 2));
      var arrive = new Date(ship); arrive.setDate(arrive.getDate() + 4);
      // Bump arrival off the weekend onto the next business day (Monday).
      // Add an extra day for each weekend day we skip so it never reads "delivered Saturday".
      var dow = arrive.getDay(); // 0 = Sunday, 6 = Saturday
      if (dow === 6) arrive.setDate(arrive.getDate() + 2); // Sat → Mon (+2 days)
      else if (dow === 0) arrive.setDate(arrive.getDate() + 1); // Sun → Mon (+1 day)
      var dateStr = arrive.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
      deliveryDate.textContent = dateStr;
      if (deliveryNote) {
        deliveryNote.textContent = beforeCutoff
          ? 'Order in the next few hours for same-day dispatch'
          : 'Ships tomorrow morning from our South Carolina warehouse';
      }
    }

    // -----------------------
    // 6) Ecosystem persona switcher
    // -----------------------
    var personaBtns = root.querySelectorAll('[data-cro-persona]');
    var personaPanes = root.querySelectorAll('[data-cro-persona-pane]');
    function selectPersona(id) {
      personaBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-cro-persona') === id ? 'true' : 'false');
      });
      personaPanes.forEach(function (p) {
        p.style.display = p.getAttribute('data-cro-persona-pane') === id ? '' : 'none';
      });
    }
    personaBtns.forEach(function (b) {
      b.addEventListener('click', function () { selectPersona(b.getAttribute('data-cro-persona')); });
    });
    if (personaBtns.length) selectPersona(personaBtns[0].getAttribute('data-cro-persona'));

    // Parent CTA banner - clicking it activates the homeschool persona, then scrolls.
    root.querySelectorAll('[data-cro-persona-trigger]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var target = el.getAttribute('data-cro-persona-trigger');
        if (target) selectPersona(target);
      });
    });

    // -----------------------
    // 7) PO Quote calculator + form - REMOVED (Vendor Pack CTA panel only)
    // The PO section now routes to the Vendor Pack PDF; no JS hooks needed there.
    // The <details> wrapper around the PO section is collapsed on mobile so users
    // see one tap-row instead of a long scroll, and force-opened on desktop.
    // -----------------------
    var poDetails = root.querySelector('[data-cro-po-details]');
    if (poDetails) {
      var poDesktopMQ = window.matchMedia('(min-width: 901px)');
      var applyPoOpenState = function (e) {
        if (e.matches) poDetails.setAttribute('open', '');
        else poDetails.removeAttribute('open');
      };
      applyPoOpenState(poDesktopMQ);
      // Listen for viewport resize so the state stays in sync
      if (poDesktopMQ.addEventListener) poDesktopMQ.addEventListener('change', applyPoOpenState);
      else if (poDesktopMQ.addListener) poDesktopMQ.addListener(applyPoOpenState);
    }

    // -----------------------
    // 7.5) Mini FAQ near ATC (CRO #7) - independent toggle per question
    // -----------------------
    root.querySelectorAll('[data-cro-mini-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var answer = btn.nextElementSibling;
        if (!answer || !answer.classList.contains('cro-mini-faq__a')) return;
        var open = !answer.hasAttribute('hidden');
        if (open) {
          answer.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          answer.removeAttribute('hidden');
          btn.setAttribute('aria-expanded', 'true');
        }
        var icon = btn.querySelector('.cro-mini-faq__icon');
        if (icon) icon.textContent = open ? '+' : '−';
      });
    });

    // -----------------------
    // 8) FAQ accordion
    // -----------------------
    root.querySelectorAll('[data-cro-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-cro-faq-item]');
        if (!item) return;
        var open = item.getAttribute('data-open') === 'true';
        // Close all, open this
        root.querySelectorAll('[data-cro-faq-item]').forEach(function (it) { it.setAttribute('data-open', 'false'); });
        item.setAttribute('data-open', open ? 'false' : 'true');
        var icon = btn.querySelector('[data-cro-faq-icon]');
        if (icon) icon.textContent = open ? '+' : '−';
      });
    });

    // -----------------------
    // 9) Sticky cart - only appears AFTER the user scrolls past the entire hero section
    //    (not just the ATC button). Cleaner UX since the hero already has its own ATC.
    // -----------------------
    var sticky = document.querySelector('.cro-v1-sticky');
    if (sticky) {
      var stickyBtn = sticky.querySelector('[data-cro-add-to-cart]');
      // Observe the hero <section> itself. Sticky shows when the hero is no longer
      // intersecting the viewport (i.e., user has scrolled past the entire first product section).
      var heroSection = root.querySelector('.cro-hero').closest('section');
      if (heroSection && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            // Show sticky only when the hero section is fully out of view
            sticky.setAttribute('data-show', entry.isIntersecting ? 'false' : 'true');
          });
        }, { threshold: 0, rootMargin: '0px' });
        io.observe(heroSection);
      } else {
        // Fallback: show sticky from initial load
        sticky.setAttribute('data-show', 'true');
      }
      // Sync sticky CTA copy with the currently selected tier (CRO #9)
      var stickyNameEl = sticky.querySelector('[data-cro-sticky-name]');
      var stickyOrigName = stickyNameEl ? stickyNameEl.textContent.trim() : '';
      var syncStickyPrice = function () {
        if (!stickyBtn) return;
        var tier = TIERS[selectedTierId];
        if (tier) {
          // getActivePrice === tier.price unless the starter kit is selected
          stickyBtn.textContent = 'Add To Cart · ' + fmt(getActivePrice(tier));
        }
      };
      // Re-sync whenever selectTier runs
      var origSelectTier = selectTier;
      selectTier = function (id) {
        origSelectTier(id);
        syncStickyPrice();
      };
      syncStickyPrice();
    }

    // -----------------------
    // 10) Add-to-cart submission
    // Posts to Shopify /cart/add.js with the variantId × tier qty.
    // Starter tier posts TWO items in one call: the Value Pack variant plus
    // the Educator Starter Pack add-on product (JSON items form).
    // Fires window event 'cro-v1:added-to-cart' for analytics + theme to react.
    // -----------------------
    // Effective kit key for variant lookup. The starter tier ships the VALUE
    // PACK variant (the add-on product is posted alongside it in addToCart),
    // so starter maps to the value variant. Non-starter kits pass through
    // untouched - identical to legacy behavior.
    function getKitKey() {
      if (hasStarter && selectedKit === 'starter') return 'value';
      return selectedKit;
    }
    function getSelectedVariantId() {
      var tier = TIERS[selectedTierId];
      if (!tier) return config.defaultVariantId || null;
      var kitKey = getKitKey();
      // New shape: tier.variants = { standard: id, value: id }
      if (tier.variants && tier.variants[kitKey]) {
        return tier.variants[kitKey];
      }
      // Fallback for legacy shape (single variantId per tier)
      if (tier.variantId) return tier.variantId;
      return config.defaultVariantId || null;
    }
    function getCartQty() {
      var manualQty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      // Each (tier × kit) is its own dedicated Shopify variant priced at the tier total,
      // so we always add quantity = manualQty (no multiplication). The tier's "cartQty"
      // field is kept for legacy single-variant fallback only.
      var tier = TIERS[selectedTierId];
      if (tier && (!tier.variants || !tier.variants[getKitKey()]) && tier.cartQty) {
        return tier.cartQty * manualQty;
      }
      return manualQty;
    }

    function addToCart(button) {
      var variantId = getSelectedVariantId();
      if (!variantId) {
        console.warn('[cro-v1] no variantId available; falling back to first variant in DOM');
      }
      var qty = getCartQty();
      var origText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';

      // Match Dawn's pattern: request the drawer's sections back so we can call
      // cartDrawer.renderContents(response) - that re-renders AND opens the drawer.
      var cartDrawer = document.querySelector('cart-drawer');
      var cartNotification = document.querySelector('cart-notification');
      var renderTarget = cartDrawer || cartNotification;
      var sectionsList = null;
      if (renderTarget && typeof renderTarget.getSectionsToRender === 'function') {
        try {
          sectionsList = renderTarget.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        } catch (e) {}
      }

      var fetchOptions;
      if (hasStarter && selectedKit === 'starter' && STARTER_ADDON_ID) {
        // Starter tier = Value Pack variant + Educator Starter Pack add-on
        // product, posted together in ONE /cart/add.js call via the JSON items
        // form. /cart/add.js accepts top-level "sections" and "sections_url"
        // in the JSON body too, so the drawer renderContents flow still works.
        var payload = {
          items: [
            { id: variantId, quantity: qty },
            { id: STARTER_ADDON_ID, quantity: qty }
          ]
        };
        if (sectionsList !== null) {
          payload.sections = sectionsList;
          payload.sections_url = window.location.pathname;
        }
        fetchOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload),
        };
      } else {
        // Legacy single-item FormData path - unchanged behavior for the
        // Standard Kit and Value Pack on every PDP (including the workbook).
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', qty);
        if (sectionsList !== null) {
          fd.append('sections', sectionsList);
          fd.append('sections_url', window.location.pathname);
        }
        fetchOptions = {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
          body: fd,
        };
      }

      fetch('/cart/add.js', fetchOptions)
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            console.warn('[cro-v1] cart add failed', res.data);
            button.textContent = 'Error · try again';
            setTimeout(function () { button.textContent = origText; button.disabled = false; }, 2400);
            return;
          }
          // Fire events for analytics / Klaviyo / GTM listeners
          try {
            window.dispatchEvent(new CustomEvent('cro-v1:added-to-cart', { detail: res.data }));
            document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: res.data }));
            // Dawn pub/sub - if present, downstream subscribers (cart icon bubble, etc) update
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'cro-v1-pdp',
                productVariantId: variantId,
                cartData: res.data,
              });
            }
          } catch (e) {}

          var didOpenDrawer = false;
          // Preferred path: render + open the Dawn cart drawer
          if (renderTarget && typeof renderTarget.renderContents === 'function') {
            try {
              renderTarget.renderContents(res.data);
              didOpenDrawer = true;
            } catch (e) {
              console.warn('[cro-v1] renderContents failed', e);
            }
          }
          // Fallback: click an existing drawer-open trigger
          if (!didOpenDrawer) {
            var drawerOpener = document.querySelector('[data-cart-drawer-open], .cart-drawer-toggle, [aria-controls="CartDrawer"]');
            if (drawerOpener && typeof drawerOpener.click === 'function') {
              drawerOpener.click();
              didOpenDrawer = true;
            }
          }

          button.textContent = '✓ Added to cart';
          setTimeout(function () {
            button.textContent = origText;
            button.disabled = false;
            // Last resort: send the user to /cart so they don't get stuck
            if (!didOpenDrawer && config.fallbackNavigateToCart) {
              window.location.href = '/cart';
            }
          }, 1100);
        })
        .catch(function (err) {
          console.warn('[cro-v1] cart add error', err);
          button.textContent = 'Error · try again';
          setTimeout(function () { button.textContent = origText; button.disabled = false; }, 2400);
        });
    }

    root.querySelectorAll('[data-cro-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(btn);
      });
    });
    if (sticky) {
      var stickyBtn = sticky.querySelector('[data-cro-add-to-cart]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function (e) {
          e.preventDefault();
          addToCart(stickyBtn);
        });
      }
    }

    // -----------------------
    // 11) Intelligems / analytics ping (no-op shim for the variant)
    // -----------------------
    try {
      window.dispatchEvent(new CustomEvent('cro-v1:rendered', {
        detail: { product: config.productHandle, ts: Date.now() }
      }));
    } catch (e) {}
  });
})();
